import {Component, Injector} from '@angular/core';
import {ProductParameterFormatState, Store as ProductParameterFormatStore} from './state/store';
import {ProductParameterFormat} from './state/model';
import {ProductParameterFormatService as ProductParameterFormatService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {ProductParameterFormatQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class ProductParameterFormatDetailComponent extends EntityDetailComponent<ProductParameterFormat, ProductParameterFormatState, ProductParameterFormatStore> {

  constructor(
    public injector: Injector,
    service: ProductParameterFormatService,
    protected query: ProductParameterFormatQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
